module.exports = __webpack_public_path__ + "img/login-logo.bb11d161.png";